import {renderGoods} from "./render-goods";
import {renderBannerList} from "./render-banner-list";
import {renderNewsList} from "./render-news-list";
// import { renderProductList1 } from "./render-product-list-1";


export const renderIndexPage = () => {
  // Баннеры
  const bannerElement = document.querySelector(`.banner`);
  if (bannerElement) {
    renderBannerList(bannerElement, bannerList);
  }

  // акционные товары
  // const actionsElement1 = document.querySelector(`.main-page__section--actions`);
  // if (actionsElement1) {
  //   renderProductList1(actionsElement1, actionList);
  // }

  // акционные товары
  const mainPageElement = document.querySelector(`.main-page`);
  if (mainPageElement) {
    renderGoods(mainPageElement, `main-page`, `actions`, actionList);
    renderNewsList(mainPageElement, newsList);
    renderGoods(mainPageElement, `main-page`, `recents`, recentsList);
  }

  // Новости
  // const newsElement = document.querySelector(`.main-page`);
  // if (newsElement) {
  // }

  // просмотренные товары
  // const recentsElement1 = document.querySelector(`.main-page__section--recents`);
  // if (recentsElement1) {
  //   renderProductList1(recentsElement1, recentsList);
  // }

  // просмотренные товары
  // const recentsElement = document.querySelector(`.main-page`);
  // // const recentsElement = document.querySelector(`.main-page__section--recents`);
  // if (recentsElement) {
  // }
};
